"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageError = void 0;
var tslib_1 = require("tslib");
var MessageError = /** @class */ (function (_super) {
    tslib_1.__extends(MessageError, _super);
    function MessageError(msg) {
        var _a;
        var _this = _super.call(this, "Received error from IRC server: " + ((_a = msg.rawLine) !== null && _a !== void 0 ? _a : '[message internally built]')) || this;
        _this.ircMessage = msg;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, _this.constructor);
        }
        return _this;
    }
    Object.defineProperty(MessageError.prototype, "name", {
        get: function () {
            return this.constructor.name;
        },
        enumerable: false,
        configurable: true
    });
    return MessageError;
}(Error));
exports.MessageError = MessageError;
